export default __webpack_public_path__ + "static/media/dot_black.c686b2c5.jpg";